import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import dayjs from "dayjs";

const EmailMonthlyMileageModal = ({ open, onClose, onSend }) => {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [monthOptions, setMonthOptions] = useState([]);

  useEffect(() => {
    const getLastSixMonths = () => {
      const months = [];
      for (let i = 0; i < 6; i++) {
        const date = dayjs().subtract(i, "month");
        months.push({
          label: date.format("MMMM YYYY"),
          value: date.format("YYYY-MM"),
        });
      }
      return months;
    };
    setMonthOptions(getLastSixMonths());
  }, []);

  const handleSend = () => {
    if (selectedMonth) {
      onSend(selectedMonth); // selectedMonth is in YYYY-MM format
      setSelectedMonth("");
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: "#ffffff",
          boxShadow: 4,
          px: 3,
          py: 2,
          minWidth: 400,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, fontSize: "1.2rem" }}>
      Email Monthly Mileage
      </DialogTitle>

      <DialogContent>
        <Select
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          displayEmpty
          fullWidth
          sx={{
            backgroundColor: "#f8f9fa",
            borderRadius: 1,
            mt: 1,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#e0e0e0',
            },
          }}
        >
          <MenuItem value="" disabled>
            Select a month
          </MenuItem>
          {monthOptions.map((month) => (
            <MenuItem key={month.value} value={month.value}>
              {month.label}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "flex-end", px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            color: "#333",
          }}
        >
          Cancel
        </Button>
        <Button
  variant="contained"
  color="primary" // 🎯 This matches the existing button
  onClick={handleSend}
  disabled={!selectedMonth}
  sx={{
    textTransform: "none",
    borderRadius: 2,
    boxShadow: 2,
    ml: 1,
  }}
>
  Send Email
</Button>


      </DialogActions>
    </Dialog>
  );
};

export default EmailMonthlyMileageModal;
